module.exports = __webpack_public_path__ + "static/assets/8dc7c84edb22caf8d6fee191f7a6acf9.gif";